import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import options from './config-base';

i18n.use(initReactI18next).init(options);

export default i18n;
